/**
 * RTL utility functions
 */

export const getDirection = (language) => {
  return language === 'ar' || language === 'ku' ? 'rtl' : 'ltr';
};

export const getFontFamily = (language) => {
  if (language === 'ar') {
    return 'font-arabic';
  } else if (language === 'ku') {
    return 'font-kurdish';
  }
  return 'font-english';
};

